import React from 'react';
import { Select } from 'antd';
import {
  PROFILE_ACCOUNTANT,
  PROFILE_ADMINISTRADOR,
  PROFILE_DOCTOR,
  PROFILE_FINANCIAL,
  PROFILE_FINANCIAL_ADMINISTRATOR,
  PROFILE_OTHER,
  PROFILE_PARTNERSHIP,
  PROFILE_RECEPTIONIST,
  PROFILE_STUDENT
} from 'constants/types';
import { display } from '../constants';
import SelectWrapperPrefix from './SelectWrapperPrefix';

const types = [
  {
    id: PROFILE_FINANCIAL_ADMINISTRATOR,
    name: display.PROFILES[PROFILE_FINANCIAL_ADMINISTRATOR]
  },
  { id: PROFILE_DOCTOR, name: display.PROFILES[PROFILE_DOCTOR] },
  { id: PROFILE_ADMINISTRADOR, name: display.PROFILES[PROFILE_ADMINISTRADOR] },
  { id: PROFILE_OTHER, name: display.PROFILES[PROFILE_OTHER] },
  { id: PROFILE_RECEPTIONIST, name: display.PROFILES[PROFILE_RECEPTIONIST] },
  { id: PROFILE_ACCOUNTANT, name: display.PROFILES[PROFILE_ACCOUNTANT] },
  { id: PROFILE_FINANCIAL, name: display.PROFILES[PROFILE_FINANCIAL] },
  { id: PROFILE_STUDENT, name: display.PROFILES[PROFILE_STUDENT] },
  { id: PROFILE_PARTNERSHIP, name: display.PROFILES[PROFILE_PARTNERSHIP] }
];

const SelectProfile = ({ hideProfiles = [], prefix, ...rest }) => {
  if (!prefix) {
    return (
      <Select {...rest} icon>
        {types
          .filter((c) => !hideProfiles.includes(c.id))
          .map((c) => {
            return (
              <Select.Option key={c.id} value={c.id} title={c.name}>
                {c.name}
              </Select.Option>
            );
          })}
      </Select>
    );
  }

  return (
    <SelectWrapperPrefix prefix={prefix} {...rest}>
      <Select>
        {types
          .filter((c) => !hideProfiles.includes(c.id))
          .map((c) => {
            return (
              <Select.Option key={c.id} value={c.id} title={c.name}>
                {c.name}
              </Select.Option>
            );
          })}
      </Select>
    </SelectWrapperPrefix>
  );
};

export default SelectProfile;
